<template>
    <div style="width: 100%;height: 100%;">
        <video
                ref="player"
                id="vjs_video_3_html5_api"
                src=""
                playsinline="true"
                webkit-playsinline="true"
                preload="auto"
                autoplay
                :class="{'zoom': videoAspectRatio.modes[videoAspectRatio.index] === 'zoom', 'ratio-4-3': videoAspectRatio.modes[videoAspectRatio.index] === '4:3', 'ratio-16-9': videoAspectRatio.modes[videoAspectRatio.index] === '16:9'}"
                :muted="src ? '' : 'muted'"
        ></video>

        <debug
                ref="debug"
                :hls="hls"
        ></debug>
    </div>
</template>
<script>
    import Hls from 'hls.js';
    import Debug from './Debug/Debug.vue';

    import {mapState, mapActions} from 'vuex';

    export default {
        data() {
            return {
                hls: null
//                errorCount: 0
            }
        },
        components: {Debug},
        computed: {
            ...mapState({
                videoAspectRatio: state => state.videoAspectRatio.object,
                videoOptions: state => state.videoOptions.object
//                hls: state => state.video.hls
            }),
            src() {
                return this.videoOptions.source.src;
            },
            player() {
                this.setChannelsState({player: this.$refs.player});
                return this.$refs.player;
            }
        },
        mounted() {
            if (!Hls.isSupported()) {
                alert('Your browser does not support Hls.');
                throw Error('Your browser does not support Hls.');
            }
        },
        beforeDestroy() {
            this.hls.destroy();
        },
        methods: {
            ...mapActions([
                'setLoadingChannel',
                'setChannelsState'
//                'initializeHls'
            ]),
            updatePlayer() {
                console.log('update player');
                if (this.hls) this.hls.destroy();
                if (this.src) {
//                    let hls = new Hls();
//                    this.initializeHls(hls);
                    this.hls = new Hls();
                    this.$parent.hls = this.hls;
                    this.hls.attachMedia(this.player);
                    this.hls.on(Hls.Events.MEDIA_ATTACHED, () => {
                        this.setSrc();
                        this.initErrorsEvents();
                        this.$refs.debug.enableDebug();
                    });
                }

                this.hls.on(Hls.Events.MANIFEST_LOADING, () => {
                    console.log('loading');
                    this.$parent.loadingVideo = true;
                });
                this.hls.on(Hls.Events.MANIFEST_LOADED, () => {
                    console.log('loaded');
                    setTimeout(() => {
                        this.$parent.loadingVideo = false;
                        this.setLoadingChannel(false);
                    }, 2000);
                });
            },
            setSrc() {
                this.hls.loadSource(this.src);
                this.player.play();
                this.$refs.debug.clearEvents();
            },
            initErrorsEvents() {
                this.hls.on(Hls.Events.ERROR, (event, data) => {
                    console.warn('error data', data.details, data);
                    if (data.reason === 'no ADTS header found in AAC PES') {
                        console.log('Ошибка воспроизведения фрагмента.');
                        this.$emit('setError', {code: 100, message: 'Ошибка воспроизведения фрагмента.'})
                        this.$parent.pause();
                    }
                    else {
                        // type: "networkError", details: "fragLoadError" при bad request со стороны сервера
                        if (data.type === 'networkError') {
                            if (data.details === 'levelLoadError') {
                                this.$parent.restoreWatching();
                            }
                            //                        this.hls.config.maxBufferLength = 6;
                        }
                        //                    if (this.errorCount >= 5) {
                        //                        this.errorCount = 0;
                        //                        this.$parent.restoreWatching();
                        //                    }
                        //                    else this.errorCount++;
                        // bufferStalledError если есть подвисания
                        // track all errors independently
                        this.$refs.debug.addError(data.details);
                        if (data.fatal) {
                            switch (data.type) {
                                case Hls.ErrorTypes.NETWORK_ERROR:
                                    // try to recover network error
                                    console.log("fatal network error encountered, try to recover 1");
                                    this.hls.startLoad();
                                    break;
                                case Hls.ErrorTypes.MEDIA_ERROR:
                                    console.log("fatal media error encountered, try to recover 2");
                                    this.hls.recoverMediaError();
                                    break;
                                default:
                                    console.log("fatal media error encountered, cannot recover 3");
                                    break;
                            }
                            // track fatal error
                            this.$refs.debug.addFatalError(data.details);
                            this.$parent.restoreWatching();
                        }
                    }
                });
            }
        },
        watch: {
            src() {
                this.updatePlayer();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// VideoPlayer.vue?072e440e